import { Visibility as StatusIcon } from "@mui/icons-material";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { BI_PRESETS } from "stores/bi/types";
import SelectorDialogBase from "../../../components/controls/base/SelectorDialogBase";
import Chip from "../../../components/controls/select/Chip";



interface Props {
	preset?: BI_PRESETS,
	onChange?: (preset: BI_PRESETS) => void,
	sx?: any
}

const SelectorBiPresetH: FunctionComponent<Props> = ({
	preset = BI_PRESETS.YIELD,
	onChange,
	sx,
}) => {
	// STORE

	// HOOKs
	const { t } = useTranslation()
	const [isOpen, setIsOpen] = useState(false)

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (preset: BI_PRESETS) => {
		setIsOpen(false)
		if (preset) onChange?.(preset)
	}

	// RENDER
	const presets = Object.values(BI_PRESETS)
	const getLabel = (preset:string) => preset?.toUpperCase() ?? "--"

	return (<>
		<Chip sx={sx}
			label={getLabel(preset)}
			icon={<StatusIcon />}
			tooltip={"SELECT PRESET DATA"}
			onClick={handleClick}
		/>
		<SelectorDialogBase
			width="auto"
			height={null}
			icon={<StatusIcon />}
			items={presets}
			idSelect={preset}
			title={"SELECT PRESET"}
			isOpen={isOpen}
			onClose={handleClose}
			fnTextFromItem={preset => getLabel(preset)}
		/>
	</>)
}

export default SelectorBiPresetH
